import { useIndexerQuery } from "@/shared/indexer/useIndexerQuery"
import { Offer } from "../types"
import { MARKETPLACE_CHAIN_ID } from "../marketplace-chain-id"

export function useMarketplaceOffers(assetContract: string, tokenId: bigint) {
  const query = useIndexerQuery<{
    data: { MarketplaceOffer: Offer[] }
  }>({
    commandName: "marketplaceOffers",
    variables: {
      chainId: MARKETPLACE_CHAIN_ID,
      status: "ACTIVE",
      assetContract: assetContract.toLowerCase(),
      tokenId: tokenId.toString(),
    },
    enabled: Boolean(MARKETPLACE_CHAIN_ID && assetContract && tokenId),
    select: (data) => data?.data?.MarketplaceOffer || [],
  })

  return {
    offers: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  }
}
